import mammoth from "mammoth";

export const extractDocxText = async (
    file
) => {
    const arrayBuffer =
        await file.arrayBuffer();

    const result =
        await mammoth.extractRawText({
            arrayBuffer,
        });

    return result.value;
};

export const extractDocxHtml = async (
    file
) => {
    const arrayBuffer =
        await file.arrayBuffer();

    const result =
        await mammoth.convertToHtml({
            arrayBuffer,
        });

    return result.value;
};

export const paginateHtmlContent = (html) => {
    if (!html) return [];
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const elements = Array.from(doc.body.childNodes);
    
    const pages = [];
    let currentPage = {
        type: "standard",
        title: "",
        content: "",
        fontFamily: "serif",
        fontSize: 12,
        alignment: "justify",
        images: [],
    };
    
    let currentWords = 0;
    
    const startNewPage = () => {
        if (currentPage.content.trim() || currentPage.images.length > 0) {
            pages.push(currentPage);
        }
        currentPage = {
            type: "standard",
            title: "",
            content: "",
            fontFamily: "serif",
            fontSize: 12,
            alignment: "justify",
            images: [],
        };
        currentWords = 0;
    };
    
    for (const el of elements) {
        if (el.nodeType === 3) { // Node.TEXT_NODE
            const text = el.textContent.trim();
            if (text) {
                currentPage.content += `<p>${text}</p>`;
                currentWords += text.split(/\s+/).length;
            }
        } else if (el.nodeType === 1) { // Node.ELEMENT_NODE
            const tagName = el.tagName.toLowerCase();
            
            if (tagName === "hr" || el.querySelector("hr")) {
                // Treat <hr> as a manual page break
                startNewPage();
            } else if (tagName === "img" || el.querySelector("img")) {
                const img = tagName === "img" ? el : el.querySelector("img");
                const src = img.getAttribute("src") || "";
                if (src) {
                    currentPage.content += `<div style="text-align:center;margin:12px 0;"><img src="${src}" alt="Image" style="max-width:100%;height:auto;border-radius:4px;" /></div>`;
                    currentPage.images.push({
                        url: src,
                        position: "center",
                        caption: img.getAttribute("alt") || "Embedded Image",
                    });
                }
            } else {
                const elementHtml = el.outerHTML;
                const elementText = el.textContent.trim();
                
                if (elementHtml) {
                    currentPage.content += elementHtml;
                    if (elementText) {
                        currentWords += elementText.split(/\s+/).length;
                    }
                    
                    // Paginate if page becomes too long
                    if (currentWords > 360) {
                        startNewPage();
                    }
                }
            }
        }
    }
    
    if (currentPage.content.trim() || currentPage.images.length > 0) {
        pages.push(currentPage);
    }
    
    // Ensure we have at least one page
    if (pages.length === 0) {
        pages.push({
            type: "standard",
            title: "",
            content: "<p>Start writing your manuscript here...</p>",
            fontFamily: "serif",
            fontSize: 12,
            alignment: "justify",
            images: [],
        });
    }
    
    return pages;
};